import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { CDBIcon } from 'cdbreact';
import { formatCurrency } from '../utils/recurringHelpers';

export const CancelRecurringModal = ({ show, onHide, onConfirm, payment, loading }) => {
    // COMENTADO POR SOLICITUD - PASSWORD EN CANCELACIÓN
    // const [password, setPassword] = useState('');
    // const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm(); // Se llama sin contraseña
    };

    const handleClose = () => {
        // setPassword('');
        // setShowPassword(false);
        onHide();
    };

    if (!payment) return null;

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            centered
            backdrop="static"
            keyboard={false}
            style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
            <Modal.Header closeButton style={{ borderBottom: 'none', backgroundColor: '#FFF5F5' }}>
                <Modal.Title className="d-flex align-items-center gap-2 text-danger fw-bold" style={{ fontSize: '20px' }}>
                    <CDBIcon icon="exclamation-triangle" /> Confirmar Cancelación
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
                <p className="text-muted" style={{ fontSize: '14px' }}>
                    Estás a punto de cancelar de forma permanente el siguiente pago recurrente. Esta acción no se puede deshacer.
                </p>

                {/* Resumen del plan */}
                <div 
                    className="p-3 mb-4 rounded border" 
                    style={{ 
                        backgroundColor: '#FAFAFA', 
                        fontSize: '14px',
                        borderLeft: '4px solid #DC3545'
                    }}
                >
                    <div className="mb-2">
                        <span className="text-muted small d-block">ID del Plan</span>
                        <strong className="text-dark font-monospace" style={{ fontSize: '13px' }}>{payment.id}</strong>
                    </div>
                    <div className="row g-2">
                        <div className="col-6">
                            <span className="text-muted small d-block">Cliente</span>
                            <strong className="text-dark">{payment.customerName}</strong>
                        </div>
                        <div className="col-6">
                            <span className="text-muted small d-block">Concepto</span>
                            <strong className="text-dark">{payment.concept}</strong>
                        </div>
                        <div className="col-6 mt-2">
                            <span className="text-muted small d-block">Monto</span>
                            <strong className="text-dark">{formatCurrency(payment.amount)} {payment.currency}</strong>
                        </div>
                        <div className="col-6 mt-2">
                            <span className="text-muted small d-block">Frecuencia</span>
                            <strong className="text-dark">{payment.frequency}</strong>
                        </div>
                    </div>
                </div>

                <Form onSubmit={handleSubmit}>
                    {/* COMENTADO POR SOLICITUD - CONTRASEÑA PARA CONFIRMAR CANCELACIÓN
                    <Form.Group className="mb-3" controlId="cancelPasswordInput">
                        <Form.Label className="fw-bold text-dark mb-1" style={{ fontSize: '14px' }}>
                            Contraseña de Administrador
                        </Form.Label>
                        <div className="position-relative">
                            <Form.Control
                                type={showPassword ? "text" : "password"}
                                placeholder="Ingrese su contraseña de inicio de sesión"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={{
                                    borderRadius: '8px',
                                    paddingRight: '45px',
                                    border: '1px solid #ced4da',
                                    height: '45px'
                                }}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="btn position-absolute top-50 translate-middle-y end-0 me-2"
                                style={{ 
                                    border: 'none', 
                                    background: 'none', 
                                    color: '#6c757d',
                                    zIndex: 10
                                }}
                            >
                                <i className={`bi bi-${showPassword ? 'eye-slash' : 'eye'}`}></i>
                            </button>
                        </div>
                    </Form.Group>
                    */}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button 
                            variant="light" 
                            onClick={handleClose} 
                            disabled={loading}
                            style={{ 
                                borderRadius: '8px', 
                                fontWeight: 'bold',
                                color: '#555',
                                border: '1px solid #ccc',
                                padding: '10px 20px'
                            }}
                        >
                            Volver
                        </Button>
                        <Button 
                            type="submit" 
                            disabled={loading}
                            style={{ 
                                borderRadius: '8px', 
                                fontWeight: 'bold',
                                backgroundColor: '#DC3545',
                                border: 'none',
                                padding: '10px 20px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            {loading ? (
                                <>
                                    <Spinner size="sm" animation="border" role="status" />
                                    <span>Cancelando...</span>
                                </>
                            ) : (
                                <span>Cancelar Suscripción</span>
                            )}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};
